import Loading from "@Components/Loading";
import { sortTickets } from "@Types/tickets";
import useGetTickets from "@Hooks/useTickets";

import Lock from "./svg/Lock";
import Check from "./svg/Check";
import Folder from "./svg/Folder";
import Magnifier from "./svg/Magnifier";
import styles from "./LatestTickets.module.scss";

export default function TicketsByStatus() {
  const { data: tickets, isLoading } = useGetTickets();

  if (!tickets || !tickets.length) return null;

  if (isLoading)
    return (
      <div className={styles.flex}>
        <Loading />
      </div>
    );

  const sortedTickets = sortTickets(tickets);

  return (
    <div className={styles.root}>
      <div className={styles.header}>Ticket status</div>
      <div>
        <div className={styles.statisticsRoot}>
          <div
            className={styles.statistic}
            style={{ borderBottomColor: "#ffbb6c" }}
          >
            <Folder className={styles.svg} />
            <div className={styles.ticketInfo}>
              <div className={styles.ticketHeader}>Open tickets</div>
              <div className={styles.ticketNumber}>{sortedTickets.open}</div>
            </div>
          </div>
          <div
            className={styles.statistic}
            style={{ borderBottomColor: "#6B97F6" }}
          >
            <Magnifier className={styles.svg} />
            <div className={styles.ticketInfo}>
              <div className={styles.ticketHeader}>Tickets in progress</div>
              <div className={styles.ticketNumber}>
                {sortedTickets["in progress"]}
              </div>
            </div>
          </div>
          <div
            className={styles.statistic}
            style={{ borderBottomColor: "#10b981" }}
          >
            <Check className={styles.svg} />
            <div className={styles.ticketInfo}>
              <div className={styles.ticketHeader}>Resolved tickets</div>
              <div className={styles.ticketNumber}>{sortedTickets.solved}</div>
            </div>
          </div>
          <div
            className={styles.statistic}
            style={{ borderBottomColor: "#EB8190" }}
          >
            <Lock className={styles.svg} />
            <div className={styles.ticketInfo}>
              <div className={styles.ticketHeader}>Closed tickets</div>
              <div className={styles.ticketNumber}>{sortedTickets.closed}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
